import { ThemeProvider, Dialog, DialogContent, DialogTitle, DialogContentText, DialogActions, Button } from '@mui/material';
import { useAppContext } from 'contexts/AppContext';
import theme from "styles/customTheme";
import { useThemeContext } from 'contexts/ThemeContext';

export default function ConfirmDialog(props) {
  const { confirmDialog } = useAppContext();
  const { mainColor } = useThemeContext();
  const { contentDialog, handleCloseDialog, openDialog, titleDialog, onOkDialog, hideCancelBtn, okBtn, cancelBtn, isReverse } = confirmDialog;
  return <ThemeProvider theme={theme({ mainColor })}>
    <Dialog
      open={openDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableEscapeKeyDown
    >
      <DialogTitle id="alert-dialog-title">
        {titleDialog}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" sx={{ lineHeight: '1.5 !important' }}>
          <div dangerouslySetInnerHTML={{ __html: contentDialog }}></div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {
          isReverse ?
            <>
              <Button variant="outlined" onClick={handleCloseDialog}><span style={{ color: "var(--color-primary)" }}>{cancelBtn}</span></Button>
              {!hideCancelBtn && <Button variant="contained" onClick={() => {
                onOkDialog?.();
                handleCloseDialog();
              }}><span style={{ color: "white" }}>{okBtn}</span></Button>}
            </>
            :
            <>
              <Button variant="contained" style={{ backgroundColor: "var(--color-primary)" }} onClick={() => {
                onOkDialog?.();
                handleCloseDialog();
              }}><span style={{ color: "white" }}>{okBtn}</span></Button>
              {!hideCancelBtn && <Button variant="contained" onClick={handleCloseDialog}><span style={{ color: "white" }}>{cancelBtn}</span></Button>}
            </>
        }

      </DialogActions>
    </Dialog>
  </ThemeProvider>
}